$(document).ready(function () {
    //setTimeout(function () {
    //    equal_height_cards();
    //}, 200);

    $(".relatedArticleItem").click(function (e) {
        e.preventDefault();
        var $target = $(this);
        var promoHeading = $target.find('.ImageAboveContent--SubTitle').first().text().trim() || 'Default Promo Name';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "ga4_select_promotion",
            "ga4_data": {
                "creative_name": "Article box",
                "promotion_name": promoHeading
            }
        });
        setTimeout(function () {
            window.location = $target.find("a").attr("href");
        }, 200);

        return false;
    });

    let hideArticleParentsChildHidden = function () {
        setTimeout(function () {
         $('.relatedArticleList ').each(function () {
               var $contentDynamic = $(this);

           var $cards = $contentDynamic.find('.Promobox--SingleCard');
             var allCardsHidden = true;

             $cards.each(function () {
                 if ($(this).is(":visible")) {
                     allCardsHidden = false;
                     return false;  // Exit early if any card is visible
                 }
             });

             // If all cards are hidden, perform the action
             if (allCardsHidden) {
                   //   $(".relatedArticle").parents("div.section.vspace-sm").addClass('d-none');
                   //    $(".relatedArticleTitle").parents("div.section.vspace-sm").addClass('d-none');
                 //} else {
                 $(".relatedArticle").parents("div.section.vspace-sm").addClass('d-none');
                 $(".relatedArticleTitle").parents("div.section.vspace-sm").addClass('d-none');
                   
               } else {
                 $(".relatedArticle").parents("div.section.vspace-sm").removeClass('d-none');
                  $(".relatedArticleTitle").parents("div.section.vspace-sm").removeClass('d-none');
               }
          });
      }, 100);
  };
    hideArticleParentsChildHidden();
   $('button.Tags__Button, button.tag_Menu_Button').click(function () {
    //    //setTimeout(function (e) {
    //    //    equal_height_cards();
       //    //}, 200);
       $(".relatedArticle").parents("div.section.vspace-sm").removeClass('d-none');
       $(".relatedArticleTitle").parents("div.section.vspace-sm").removeClass('d-none');
       setTimeout(function () {
           hideArticleParentsChildHidden();
       }, 200);
    });
    $(".relatedArticle").parents("div.section.vspace-sm").addClass("bg_grey");
    $(".relatedArticleTitle").parents("div.section.vspace-sm").addClass("bg_grey");

});
//$(window).resize(function () {
//    setTimeout(function () {
//        equal_height_cards();
//    }, 200);
//});
function equal_height_cards() {

    var highestBox = 0;
    var textBox = 0;
    $('.ImageAboveContent--SubTitle').height("unset");
    $('.Promobox--SingleCard').height("unset");
    if ($(window).width() > 767) {
        $('.Promobox--SingleCard .ImageAboveContent--Content h3 ').each(function () {
            if ($(this).is(':visible')) {
                if ($(this).height() > textBox) {
                    textBox = $(this).height();
                }
            }
        });
        // Set the height of all those children to whichever was highest 
        $('.ImageAboveContent--SubTitle').height(textBox);
        $('.Promobox--SingleCard').each(function () {
            if ($(this).is(':visible')) {
                // If this box is higher than the cached highest then store it
                if ($(this).height() > highestBox) {
                    highestBox = $(this).height();
                }
            }
        });
    }
}